export default __webpack_public_path__ + "static/media/learose5-768w.bde266fc.png";